import Api from "@/api/index";
import store from "@/store";
import alerts from "@/components/alerts/alert";
// import router from "@/router";
import confirmations from "./confirmations";
import { uuid } from "vue-uuid";
import router from "@/router";
import AuthenticationService from "@/services/AuthenticationService";
import api from "@/api/index";
import staff from "./staff";

const teachers = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    register: {
      province_id: null,
    },
    queryParam: {},
    modalCreate: false,
    detail: null,
    modalDetail: false,
    modalEdit: false,
    modalTeacherSubject: false,
    paramsSubjectTeacher: null,
    activationData: null,
    activationModal: false,
    loading: false,
    action: "",
    count: "0",
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    count(state) {
      return state.count;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_ACTIVATION_DATA(state, data) {
      state.activationData = data;
    },
    SET_ACTIVATION_MODAL(state, data) {
      state.activationModal = data;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_MODAL_EDIT(state, data) {
      state.modalEdit = data;
    },
    SET_DETAIL(state, data) {
      state.detail = data;
    },
    SET_MODAL_DETAIL(state, data) {
      state.modalDetail = data;
    },
  },
  actions: {
    async getCount({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("teachers/count/all")
        .then(({ data }) => {
          state.count = data;
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          // commit("SET_DATAS", error.data);
        });
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("teachers")
        .then(({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    activation({ commit }, payload) {
      commit("SET_ACTIVATION_MODAL", true);
      commit("SET_ACTIVATION_DATA", payload);
    },
    async prosesActivation({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        `teachers/${payload.items.teacher_id}/activation`,
        payload
      ).then(({ data }) => {
        alerts.sweetalertToast("success", data.message);
        commit("SET_LOADING", false);
        commit("SET_MODAL_CREATE", false);
        commit("SET_ACTIVATION_MODAL", false);
        store.dispatch("loading/setLoading", false);
        store.dispatch("teachers/onRefresh");
      });
    },
    getSubject({ state }, subjects) {
      state.modalTeacherSubject = true;
      state.paramsSubjectTeacher = subjects;
    },
    subjectIds(subjects) {
      return subjects.map((subject) => subject.pivot.subject_id);
    },
    onRefresh({ state }) {
      store.dispatch("teachers/paginate", state.queryParam);
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("teachers/page", payload)
        .then(({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    onAction({ commit, state }, payload) {
      // console.log(JSON.stringify(payload[0]));

      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
        state.action = "create";
        state.register = {};
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Edit") {
        state.action = "update";
        state.register = payload[0];
        // commit("SET_DETAIL", payload[0]);
        store.dispatch("regions/getRegency", payload[0]["province_id"]);
        store.dispatch("regions/getDistrict", payload[0]["regency_id"]);
        store.dispatch("regions/getVillage", payload[0]["district_id"]);
        commit("SET_MODAL_EDIT", true);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `teachers/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      // console.log(JSON.stringify(params));
      return await AuthenticationService.putFormData("teachers", state.register)
        .then((response) => {
          alerts.sweetalertToast("success", response.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("teachers/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.putFormData(
        "teachers/update/" + payload.teacher_id,
        state.register
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_EDIT", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("teachers/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default teachers;
